import React from 'react';
import { FormLabel, Stack } from '@mui/material';
import { LeaveWithoutSavingDialog } from '@/components/dialogs/LeaveWithoutSavingDialog';
import { AdminLedgerPicker } from '../shared/pickers/AdminLedgerPicker';
import { AdminBrokerGroupPicker } from '../shared/pickers/AdminBrokerGroupPicker';
import { useFormFieldConfigScope } from './useFormFieldConfigScope';
import { useGuardedScopeChange } from './useGuardedScopeChange';
import { SCOPES } from '@/features/config/scopes';

/**
 * Picks which ledger, or which broker group (in any ledger), the ledger and broker group
 * tabs show and edit. Nothing on the default tab. Picking another asks first when there are
 * unsaved changes.
 */
export const FormFieldConfigScopePicker = () => {
	const { scope } = useFormFieldConfigScope();
	const { requestScopeChange, leaveDialogProps } = useGuardedScopeChange();

	if (scope.scope === SCOPES.DEFAULT) {
		return null;
	}

	const handleChange = (scopeId) => requestScopeChange({ scope: scope.scope, scopeId });

	return (
		<Stack sx={{ width: '25%', pb: 2 }}>
			{scope.scope === SCOPES.LEDGER ? (
				<>
					<FormLabel>Ledger</FormLabel>
					<AdminLedgerPicker multiple={false} value={scope.scopeId} onChange={handleChange} />
				</>
			) : (
				<>
					<FormLabel>Broker group</FormLabel>
					<AdminBrokerGroupPicker
						multiple={false}
						value={scope.scopeId}
						onChange={handleChange}
					/>
				</>
			)}
			<LeaveWithoutSavingDialog {...leaveDialogProps} />
		</Stack>
	);
};

FormFieldConfigScopePicker.displayName = 'FormFieldConfigScopePicker';
